<template>
  <offer-sale-base :offer-sale="offerSale" :is-group="isGroup" :type="type" :is-activable="isActivable">
    <template v-slot:line-1>
      <offer-sale-line :line-items="isGroup ? quantityOrDiscount : productInfoItems" />
    </template>

    <template v-if="!isGroup" v-slot:line-2>
      <offer-sale-line :line-items="quantityOrDiscount" />
    </template>
  </offer-sale-base>
</template>

<script>
import OfferSaleBase from './OfferSaleBase.vue'
import OfferSaleLine from './OfferSaleLine.vue'

export default {
  name: 'ComboOfferSale',
  components: {
    OfferSaleBase,
    OfferSaleLine,
  },
  props: {
    offerSale: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    isActivable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isGroup() {
      return this.offerSale[this.type] && this.offerSale[this.type].length > 0
    },
    productInfoItems() {
      return [
        {
          label: 'SKU',
          value: this.offerSale.sku,
          format: 'text',
        },
        {
          label: 'EAN',
          value: this.offerSale.ean,
          format: 'text',
        },
      ]
    },
    quantityOrDiscount() {
      switch (this.type) {
        case 'trigger_products':
          return this.quantityItem
        case 'target_products':
          return this.discountItem
        default:
          return [
            {
              label: '',
              value: '',
              format: 'text',
            },
          ]
      }
    },
    quantityItem() {
      return [
        {
          label: 'Quantidade',
          value: this.offerSale.quantity,
          format: 'text',
        },
      ]
    },
    discountItem() {
      return [
        {
          label: 'Desconto',
          value: this.offerSale.percentage_discount,
          format: 'percent',
        },
      ]
    },
  },
}
</script>
